import { IFontWeight } from '../types';

export const fontWeight: IFontWeight = {
  headings: '900',
  primary: '900',
  secondary: 'bold',
  tertiary: 'normal',
  link: 'bold',
  button: 'normal',
};
